
import {Injectable} from '@angular/core';
import {SwitchBoard} from './SwitchBoard';

@Injectable({
  providedIn: 'root'
})
export class ToastService{
  constructor(private switchBoard: SwitchBoard){}

  pop(type: string, message: string, data?: any, duration?: number){
    const toastObj = {
      toastId: Math.floor(Math.random() * 1000),
      type,
      message: message || '',
      toastClass: 'toast-success',
      data,
      duration
    };
    switch (type){
      case 'success': {
        toastObj.toastClass = 'toast-success';
        break;
      }
      case 'error': {
        toastObj.toastClass = 'toast-error';
        break;
      }
      case 'info': {
        toastObj.toastClass = 'toast-info';
        break;
      }
      case 'warning': {
        toastObj.toastClass = 'toast-warning';
        break;
      }
      case 'confirm': {
        toastObj.toastClass = 'toast-confirm';
        break;
      }
    }
    this.switchBoard.onNewToast.next(toastObj);
  }
}
